import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';

type CreateGameRulesVersionRequest = {
  title: string;
  version?: string;
  type?: string;
  rules_text: string;
  is_default?: boolean;
  status?: string;
};

type GameRulesVersion = {
  id: string;
  title: string;
  version?: string;
  type: string;
  rules_text: string;
  is_default: boolean;
  status: string;
  created_at: string;
  updated_at: string;
};

type CreateGameRulesVersionResponse = {
  rules_version: GameRulesVersion;
};

export const createGameRulesVersion = (
  data: CreateGameRulesVersionRequest
): Promise<CreateGameRulesVersionResponse> =>
  apiClient.post(
    '/api/admin/squares/game-rules' as any,
    data
  ) as Promise<CreateGameRulesVersionResponse>;

export const useCreateGameRulesVersionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createGameRulesVersion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['game-rules'] });
    },
  });
};

// Backwards-compatible aliases
export const createSquaresGameRulesVersion = createGameRulesVersion;
export const useCreateSquaresGameRulesVersionMutation = useCreateGameRulesVersionMutation;
